import { render, staticRenderFns } from "./statusSelector.vue?vue&type=template&id=3b18cf59&"
import script from "./statusSelector.vue?vue&type=script&lang=js&"
export * from "./statusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports